import React, { Component } from 'react';
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {FormControl} from "react-bootstrap";
import PropTypes from "prop-types";

class PropertyDefinitionSelect extends Component {
    sortedPropertyDefinitions() {
        if(this.props.propertyDefinitions && this.props.propertyDefinitions[this.props.customerId] &&
            this.props.propertyDefinitions[this.props.customerId].data) {
            return Object.keys(this.props.propertyDefinitions[this.props.customerId].data).map(key =>
                this.props.propertyDefinitions[this.props.customerId].data[key]
            ).filter(propertyDefinition => {
                return !this.props.allowPropertyTypes || this.props.allowPropertyTypes.indexOf(propertyDefinition.type) !== -1;
            }).sort(function (a, b) {
                if (a.description < b.description) return -1;
                if (a.description > b.description) return 1;
                return 0;
            })
        }
        else {
            return [];
        }
    }

    selectedPropertyDefinition(e) {
        let pd = this.props.propertyDefinitions[this.props.customerId].data.find(pd => pd.id === e.target.value);
        this.props.onChange(pd)
    }

    getSelectedId() {
        return this.props.selectedId ? this.props.selectedId : "";
    }

    hasEmptyId() {
        return !this.getSelectedId() || this.getSelectedId().trim() === "";
    }

    render() {
        return (
            <FormControl componentClass="select" placeholder="select" value={this.getSelectedId()} onChange={e => this.selectedPropertyDefinition(e)}>
                {this.props.allowEmpty || this.hasEmptyId() ?
                    <option key={""} value={""}>
                        {this.props.displayWhenEmpty}
                    </option>
                    : null
                }
                {this.sortedPropertyDefinitions().map(propDef =>
                    <option key={propDef.id} value={propDef.id}>
                        {propDef.description}  -  {propDef.propertyKey}
                    </option>
                )}
            </FormControl>
        );
    }
}


PropertyDefinitionSelect.propTypes = {
    customerId: PropTypes.string.isRequired,
    selectedId: PropTypes.string,
    allowPropertyTypes: PropTypes.array,
    allowEmpty: PropTypes.bool,
    displayWhenEmpty: PropTypes.string
};

const mapStateToProps = state => {
    return { propertyDefinitions: state.propertyDefinitions};
};

export default withRouter(connect(mapStateToProps)(PropertyDefinitionSelect));



// WEBPACK FOOTER //
// ./src/components/reusables/PropertyDefinitionSelect.js